export default __webpack_public_path__ + "static/media/tabbar_logo1.af4b7a97.png";